/* ===================================================================
   MINICART  →  assets/cart-drawer.js
   Käyttää Shopifyn Cart AJAX API:a:
     GET  /cart.js
     POST /cart/add.js
     POST /cart/change.js
   Hinnat/valuutta tulevat Shopifyltä (item.final_line_price, cart.total_price)
   valmiiksi muotoiltuina — ei käsin laskettuja hintoja/veroja.
   =================================================================== */
(function () {
  function init() {
    var overlay = document.querySelector('[data-cart-overlay]');
    var drawer = document.querySelector('[data-cart-drawer]');
    var body = document.querySelector('[data-cart-body]');
    if (!drawer || !overlay || !body) return;

    var cartIcon = document.getElementById('cart-icon-bubble');
    var foot = drawer.querySelector('[data-cart-foot]');
    var lastFocus = null;

  /* ---------- Rahan muotoilu ----------
     Pakotettu suomalainen euromuoto: "1 234,56 €"
       - välilyönti (kapea sitomaton) tuhaterottimena
       - pilkku desimaalierottimena
       - euromerkki hinnan JÄLKEEN, sitomattomalla välilyönnillä
     Ei nojata kaupan money_formatiin (voi olla euro edessä tms.) eikä
     Shopify.formatMoneyyn (jota teema ei lataa).
     Syöte = senttejä (kokonaisluku), kuten /cart.js palauttaa. */
  var THIN = '\u202f';      // narrow no-break space (tuhaterotin)
  var NBSP = '\u00a0';      // no-break space (ennen €-merkkiä)

  function groupThousands(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  function formatMoney(cents) {
    var neg = cents < 0;
    var n = Math.abs(Number(cents) || 0);
    // Näytä desimaalit aina (26,00 €). Jos halutaan piilottaa tasaeurot,
    // vaihda seuraava rivi ehdolliseksi.
    var value = (n / 100).toFixed(2);
    var parts = value.split('.');
    var intPart = groupThousands(parts[0], THIN);
    var body = intPart + ',' + parts[1];
    return (neg ? '-' : '') + body + NBSP + '\u20ac';
  }

  // VAT-tietoinen muotoilu: käyttää window.VAT.format jos ladattu (näyttää ALV 0
  // -näkymän), muuten normaali verollinen muoto.
  function moneyVat(cents) {
    return (window.VAT && window.VAT.format) ? window.VAT.format(cents) : formatMoney(cents);
  }

  /* ---------- Avaus / sulku ---------- */
  function openDrawer() {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    // pakota reflow ennen transitionia
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- UI-tekstit: window.themeT (theme.liquid, locale-tiedostoista) ---------- */
  function T(k, f) { return (window.themeT && window.themeT[k]) || f; }

  /* ---------- Rivin lisätiedot (peili: snippets/cart-item-props.liquid) ---------- */
  var TRAINING_KEY = 'Koulutuspäivä';
  function fmtDate(v) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
    return m ? (+m[3]) + '.' + (+m[2]) + '.' + m[1] : v;
  }
  function propsHTML(item) {
    var props = item.properties || {};
    var rows = '', training = false;
    Object.keys(props).forEach(function (k) {
      var v = props[k] == null ? '' : String(props[k]).trim();
      if (!v || k.charAt(0) === '_') return;
      var label = k;
      if (k === TRAINING_KEY) { training = true; label = drawer.dataset.tTrainingDate || k; }
      rows += '<div class="cart-props__row"><dt>' + escapeHtml(label) + '</dt><dd>' + escapeHtml(fmtDate(v)) + '</dd></div>';
    });
    if (!rows) return '';
    if (training) {
      var q = item.quantity;
      var persons = q === 1 ? (drawer.dataset.tPersonOne || '1')
                            : (drawer.dataset.tPersonOther || '%n').replace('%n', q);
      rows += '<div class="cart-props__row"><dt>' + escapeHtml(drawer.dataset.tParticipants || '') + '</dt><dd>' + escapeHtml(persons) + '</dd></div>';
    }
    return '<dl class="cart-props' + (training ? ' cart-props--training' : '') + '">' + rows + '</dl>';
  }

  /* ---------- Renderöinti ---------- */
  function itemHTML(item, line, rfqMode) {
    var img = item.image
      ? '<img src="' + safeUrl(item.image.replace(/(\.[^.]*)$/, '_160x$1')) + '" alt="" width="68" height="68" loading="lazy">'
      : '';
    var variant = (item.product_has_only_default_variant)
      ? ''
      : '<div class="cart-item__variant">' + escapeHtml(item.variant_title || '') + '</div>';
    // RFQ-tilassa KAIKKI rivit näyttävät "Tarjouspyyntö" (myös hinnalliset) → ei sekaannusta.
    var onSale = item.original_line_price > item.final_line_price;
    var priceHTML;
    if (rfqMode) {
      var qLabel = (window.RFQ && window.RFQ.cfg.priceLabel) || 'Tarjouspyyntö';
      priceHTML = '<span class="cart-item__price-now cart-item__price-now--quote">' + escapeHtml(qLabel) + '</span>';
    } else if (onSale) {
      priceHTML = '<span class="cart-item__price-now cart-item__price-now--sale" data-price="' + item.final_line_price + '">' + moneyVat(item.final_line_price) + '</span>' +
        '<s class="cart-item__price-was" data-price="' + item.original_line_price + '">' + moneyVat(item.original_line_price) + '</s>';
    } else {
      priceHTML = '<span class="cart-item__price-now" data-price="' + item.final_line_price + '">' + moneyVat(item.final_line_price) + '</span>';
    }
    return '' +
      '<li class="cart-item" data-cart-item data-line="' + line + '" data-key="' + item.key + '">' +
      '<a href="' + safeUrl(item.url) + '" class="cart-item__img">' + img + '</a>' +
      '<div class="cart-item__info">' +
      '<a href="' + safeUrl(item.url) + '" class="cart-item__name">' + escapeHtml(item.product_title) + '</a>' +
      variant +
      propsHTML(item) +
      '<div class="cart-item__row">' +
      '<div class="qty" data-qty>' +
      '<button type="button" class="qty__btn" data-qty-down aria-label="' + escapeHtml(T('qtyDown', 'Vähennä määrää')) + '">−</button>' +
      '<span class="qty__val" data-qty-val>' + item.quantity + '</span>' +
      '<button type="button" class="qty__btn" data-qty-up aria-label="' + escapeHtml(T('qtyUp', 'Lisää määrää')) + '">+</button>' +
      '</div>' +
      '<div class="cart-item__price">' + priceHTML + '</div>' +
      '</div>' +
      '<button type="button" class="cart-item__remove" data-cart-remove>' + escapeHtml(T('remove', 'Poista')) + '</button>' +
      '</div>' +
      '</li>';
  }

  function render(cart, newKey) {
    updateBadge(cart.item_count);

    // BODY = vain lista (tai tyhjä-tila). Footer on erillinen kiinteä elementti.
    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
        '<p>' + escapeHtml(T('cartEmpty', 'Ostoskorisi on tyhjä')) + '</p>' +
        '<a href="' + safeUrl(T('allUrl', '/collections/all')) + '" class="cart-drawer__continue" data-cart-close>' + escapeHtml(T('continueShopping', 'Jatka ostoksia')) + '</a>' +
        '</div>';
      if (foot) foot.hidden = true;
      bindClose();
      return;
    }

    var rfqMode = window.RFQ && window.RFQ.cartHasQuote(cart);

    var items = cart.items.map(function (it, i) { return itemHTML(it, i + 1, rfqMode); }).join('');
    body.innerHTML = '<ul class="cart-drawer__items" role="list">' + items + '</ul>';

    // Animoi VAIN juuri lisätty rivi (ei koko listaa joka avauksella → ei "hyppyä")
    if (newKey) {
      var newRow = body.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(newKey) : newKey) + '"]');
      if (newRow) newRow.classList.add('is-new');
    }

    // Kiinteä footer: päivitä vain arvot, älä rakenna uudelleen (napit/kuuntelijat säilyvät)
    if (foot) {
      foot.hidden = false;
      var savings = foot.querySelector('[data-cart-savings]');
      var savingsAmt = foot.querySelector('[data-cart-savings-amt]');
      if (savings && savingsAmt) {
        if (cart.total_discount > 0) {
          savingsAmt.setAttribute('data-price', cart.total_discount);
          savingsAmt.textContent = moneyVat(cart.total_discount);
          savings.hidden = false;
        } else {
          savings.hidden = true;
        }
      }
      var sub = foot.querySelector('[data-cart-subtotal]');
      if (sub) { sub.setAttribute('data-price', cart.total_price); sub.textContent = moneyVat(cart.total_price); }

      // --- RFQ-tila: jos korissa on tarjouspyyntötuotteita, vaihda footerin tila ---
      var subtotalRow = foot.querySelector('.cart-drawer__subtotal');
      var savingsRow = foot.querySelector('[data-cart-savings]');
      var normalNote = foot.querySelector('[data-cart-note]');
      var checkout = foot.querySelector('[data-cart-checkout]');
      var viewcart = foot.querySelector('[data-cart-viewcart]');
      var rfqNote = foot.querySelector('[data-cart-rfq-note]');
      var rfqSubmit = foot.querySelector('[data-cart-rfq-submit]');
      var buyerWrap = foot.querySelector('[data-cart-buyer]');
      if (subtotalRow) subtotalRow.hidden = !!rfqMode;
      if (rfqMode && savingsRow) savingsRow.hidden = true;
      if (normalNote) normalNote.hidden = !!rfqMode;
      if (checkout) checkout.hidden = !!rfqMode;
      if (viewcart) viewcart.hidden = !!rfqMode;
      if (buyerWrap) buyerWrap.hidden = !!rfqMode;
      if (rfqNote) rfqNote.hidden = !rfqMode;
      if (rfqSubmit) rfqSubmit.hidden = !rfqMode;
      // Ostajatyyppi voi vaikuttaa kassanapin tilaan → varmista gate renderin jälkeen.
      if (window.BuyerType) window.BuyerType.refresh();
    }

    bindItemEvents();
    bindClose();
    document.dispatchEvent(new CustomEvent('cart:rendered', { detail: { root: body } }));
  }

  function updateBadge(count) {
    if (!cartIcon) return;
    var badge = cartIcon.querySelector('.header__badge');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'header__badge';
        cartIcon.appendChild(badge);
      }
      badge.textContent = count < 100 ? count : '!';
    } else if (badge) {
      badge.remove();
    }
  }

  /* ---------- Cart API ---------- */
  function fetchCart(newKey) {
    drawer.classList.add('is-loading');
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart, newKey); drawer.classList.remove('is-loading'); return cart; })
      .catch(function () { drawer.classList.remove('is-loading'); });
  }

  function changeLine(line, quantity) {
    drawer.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); drawer.classList.remove('is-loading'); return cart; })
      .catch(function () { drawer.classList.remove('is-loading'); });
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  /* ---------- Tapahtumat riveille ---------- */
  function bindItemEvents() {
    body.querySelectorAll('[data-cart-item]').forEach(function (row) {
      var line = parseInt(row.getAttribute('data-line'), 10);
      var val = row.querySelector('[data-qty-val]');
      var cur = val ? parseInt(val.textContent, 10) : 1;
      var down = row.querySelector('[data-qty-down]');
      var up = row.querySelector('[data-qty-up]');
      var rem = row.querySelector('[data-cart-remove]');
      if (down) down.addEventListener('click', function () { changeLine(line, Math.max(0, cur - 1)); });
      if (up) up.addEventListener('click', function () { changeLine(line, cur + 1); });
      if (rem) rem.addEventListener('click', function () { changeLine(line, 0); });
    });
  }

  function bindClose() {
    body.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Turvallinen href/src: salli vain suhteelliset polut ja http(s), estä
  // javascript:/data:/vbscript: ja escapoi HTML-attribuuttiin.
  function safeUrl(raw) {
    var s = String(raw == null ? '' : raw).trim();
    if (s === '') return '';
    var stripped = s.replace(/[\u0000-\u001F\u007F]/g, '').toLowerCase();
    if (/^(javascript|data|vbscript|file):/.test(stripped)) return '';
    return escapeHtml(s);
  }

  /* ---------- Globaalit kuuntelijat ---------- */
  // Korin ikoni avaa drawerin (delegoitu dokumenttiin → ei riipu latausjärjestyksestä,
  // osuu myös kun klikataan badge/svg ikonin sisällä). Estä siirtyminen /cart-sivulle.
  document.addEventListener('click', function (e) {
    var icon = e.target.closest('#cart-icon-bubble');
    if (!icon) return;
    e.preventDefault();
    openDrawer();
    fetchCart();
  });

  // Sulku: overlay, close-nappi, Esc
  overlay.addEventListener('click', closeDrawer);
  drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Tarjouspyyntö-nappi drawerin footerissa → ohjaa palveluun korin sisällöllä
  if (foot) {
    var rfqBtn = foot.querySelector('[data-cart-rfq-submit]');
    if (rfqBtn) rfqBtn.addEventListener('click', function () {
      if (window.RFQ) window.RFQ.fetchAndSubmit();
    });
  }

  // Kaappaa kaikki "lisää koriin" -lomakkeet (tuotesivu + kortit)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"], form[data-cart-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"], [name="add"]');

    // --- RFQ: sekakorin varmistus ---
    // Jos lisättävä tuote on tarjouspyyntötuote (data-rfq-quote) JA korissa on jo
    // normihintaisia tuotteita, kysy varmistus ennen lisäystä. Vahvistuksen jälkeen
    // koko kori on tarjouspyyntötilassa (näkyy footerin vaihtuessa render()issä).
    var addingQuote = btn && btn.hasAttribute('data-rfq-quote');
    if (addingQuote && window.RFQ) {
      // Estä uusi varmistuskierros: jatka vasta kun tila tunnetaan.
      proceedWithAdd();
      return;

      function proceedWithAdd() {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var items = cart.items || [];
            var hasPriced = items.some(function (it) { return !window.RFQ.isQuoteItem(it); });
            var alreadyQuote = items.some(function (it) { return window.RFQ.isQuoteItem(it); });
            // Varmistus VAIN kun kori on hinnallinen EIKÄ vielä tarjouspyyntötilassa
            // (eli ensimmäinen siirtymä). Jos kori on jo tarjouspyynnössä → ei kysytä.
            if (hasPriced && !alreadyQuote) {
              var ask = window.RFQ.confirm
                ? window.RFQ.confirm({ message: window.RFQ.cfg.confirmText })
                : Promise.resolve(window.confirm(window.RFQ.cfg.confirmText));
              ask.then(function (ok) { if (ok) runAdd(form, btn); });
              return;
            }
            runAdd(form, btn);
          })
          .catch(function () { runAdd(form, btn); });
      }
    }

    runAdd(form, btn);
  });

  function runAdd(form, btn) {
    // Kortin kori-ikoni: ikonipohjainen tila (spinner→check→kori), EI tekstiä
    var isIconBtn = btn && btn.hasAttribute('data-pcard-add');
    var origText = (btn && !isIconBtn) ? btn.textContent : '';

    if (btn) {
      btn.disabled = true;
      if (isIconBtn) {
        btn.classList.remove('is-added');
        btn.classList.add('is-loading');
      } else {
        btn.textContent = T('adding', 'Lisätään…');
      }
    }

    addToCart(new FormData(form))
      .then(function (added) {
        if (cartIcon) {
          cartIcon.classList.remove('is-bump');
          void cartIcon.offsetWidth;
          cartIcon.classList.add('is-bump');
        }
        openDrawer();
        // added.key = juuri lisätty rivi → vain se animoituu (ei koko lista)
        return fetchCart(added && added.key);
      })
      .then(function () {
        if (!btn) return;
        btn.disabled = false;
        if (isIconBtn) {
          // spinner → check hetkeksi, sitten takaisin kori-ikoniksi
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); btn.blur(); }, 1400);
        } else {
          btn.textContent = origText;
        }
      })
      .catch(function (err) {
        if (btn) {
          btn.disabled = false;
          if (isIconBtn) { btn.classList.remove('is-loading', 'is-added'); btn.blur(); }
          else { btn.textContent = origText; }
        }
        var msg = (err && err.description) ? err.description : T('addFailed', 'Lisääminen epäonnistui.');
        alert(msg);
      });
  }

  /* ---------- Julkinen API muille moduuleille (esim. lisävarusteet) ----------
     addItems(items): lisää monta tuotetta yhdellä /cart/add.js items[] -kutsulla,
     avaa drawerin ja päivittää korin. items = [{ id, quantity }].
     Määritelty init():n SISÄLLÄ → openDrawer/fetchCart/cartIcon näkyvissä. */
  window.CartDrawer = window.CartDrawer || {};
  window.CartDrawer.addItems = function (items) {
    if (!items || !items.length) return Promise.resolve(null);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (res) {
        if (cartIcon) {
          cartIcon.classList.remove('is-bump');
          void cartIcon.offsetWidth;
          cartIcon.classList.add('is-bump');
        }
        openDrawer();
        return fetchCart().then(function () { return res; });
      });
  };
  // refresh(): avaa drawerin ja päivittää korin (käytetään kun tuotteet on jo lisätty).
  window.CartDrawer.refresh = function () {
    if (cartIcon) {
      cartIcon.classList.remove('is-bump');
      void cartIcon.offsetWidth;
      cartIcon.classList.add('is-bump');
    }
    openDrawer();
    return fetchCart();
  };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();